import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type Language = 'ru' | 'ky';

export interface UiState {
  locale: Language;
  siderCollapsed: boolean;
}

const initialState: UiState = {
  locale: (localStorage.getItem('language') as Language | null) ?? 'ru',
  siderCollapsed: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    localeChanged: (state, action: PayloadAction<Language>) => {
      state.locale = action.payload;
    },
    siderToggled: (state, action: PayloadAction<boolean | undefined>) => {
      state.siderCollapsed = action.payload ?? !state.siderCollapsed;
    },
  },
});

export const { localeChanged, siderToggled } = uiSlice.actions;
export const uiReducer = uiSlice.reducer;
